import { FONT_TITLE } from '../../constants/AppConstants';

export default class LoadDisplay extends Phaser.Group {
  constructor(game, showText = true, boomLogo = false, progress = 0) {
    super(game);

    this.animation = this.game.make.sprite(0, 0, 'loading');
    this.animation.animations.add('run');
    this.animation.animations.play('run', 24, true);
    this.add(this.animation);

    this.progress = progress;
    this.showText = showText;

    const fontStyle = {
      font: '45px ' + this.game.titleFontStyle,
      fill: '#FFFFFF',
      align: 'center',
      wordWrap: true,
      wordWrapWidth: this.animation.width,
      boundsAlignH: 'center',
      boundsAlignV: 'top',
    };

    if (this.showText) {
      this.copy = this.game.make.text(0, 0, this.game.copy.getCopy('loading'), fontStyle);
      this.copy.setTextBounds(0, 0, this.animation.width);
      this.add(this.copy);

      this.copy.y = this.animation.height + 20;
    }

    if (boomLogo) {
      this.boomLogo = this.game.make.sprite(0, 0, 'boomerang_logo');
      this.boomLogo.x = this.animation.width * 0.5 - this.boomLogo.width * 0.5;
      this.boomLogo.y = this.animation.height + 120;
      this.add(this.boomLogo);
    }
  }

  get width() {
    return this.animation.width * this.scale.x;
  }

  get height() {
    return this.animation.height * this.scale.y;
  }

  update() {
    if (this.showText && this.progress != 0) {
      this.copy.setText(this.game.copy.getCopy('loading') + ' ' + this.progress + '%');
    }
  }

  destroy() {
    if (this.animation) {
      this.animation.destroy(true);
      this.animation = null;
    }
    if (this.copy) {
      this.copy.destroy(true);
      this.copy = null;
    }
    super.destroy(true);
  }
}



// WEBPACK FOOTER //
// ./js/app/display/ui/LoadDisplay.js